import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";


function normalizeRequiredString(
  value,
  fieldName,
) {
  if (
    typeof value !== "string"
    || !value.trim()
  ) {
    throw new TypeError(
      `${fieldName} is required.`,
    );
  }

  return value.trim();
}


export function buildSupplierCapabilitiesBasePath(
  supplierUuid,
) {
  const normalizedSupplierUuid =
    normalizeRequiredString(
      supplierUuid,
      "supplierUuid",
    );

  return (
    "/supply-chain/suppliers/"
    + encodeURIComponent(
      normalizedSupplierUuid,
    )
    + "/capabilities"
  );
}


export function buildSupplierCapabilityPath(
  supplierUuid,
  capabilityUuid,
) {
  const normalizedCapabilityUuid =
    normalizeRequiredString(
      capabilityUuid,
      "capabilityUuid",
    );

  return (
    buildSupplierCapabilitiesBasePath(
      supplierUuid,
    )
    + "/"
    + encodeURIComponent(
      normalizedCapabilityUuid,
    )
  );
}


function buildSupplierCapabilityScopeConfig({
  companyUuid,
  activityUuid,
} = {}) {
  return {
    headers: {
      ...buildCompanyScopeHeaders(
        companyUuid,
      ),
      ...buildActivityScopeHeaders(
        activityUuid,
      ),
    },
  };
}


export function getSupplierCapabilityErrorMessage(
  error,
  fallback = (
    "Unable to process the supplier capability request."
  ),
) {
  return (
    error?.response?.data?.message
    || error?.response?.data?.error
    || error?.message
    || fallback
  );
}


export async function listSupplierCapabilities(
  supplierUuid,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  const response = await api.get(
    buildSupplierCapabilitiesBasePath(
      supplierUuid,
    ),
    buildSupplierCapabilityScopeConfig({
      companyUuid,
      activityUuid,
    }),
  );

  return response?.data?.capabilities
    || [];
}


export async function getSupplierCapability(
  supplierUuid,
  capabilityUuid,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  const response = await api.get(
    buildSupplierCapabilityPath(
      supplierUuid,
      capabilityUuid,
    ),
    buildSupplierCapabilityScopeConfig({
      companyUuid,
      activityUuid,
    }),
  );

  return response?.data?.capability
    || null;
}


export async function createSupplierCapability(
  supplierUuid,
  payload,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  const response = await api.post(
    buildSupplierCapabilitiesBasePath(
      supplierUuid,
    ),
    payload,
    buildSupplierCapabilityScopeConfig({
      companyUuid,
      activityUuid,
    }),
  );

  return response?.data?.capability
    || null;
}


export async function updateSupplierCapability(
  supplierUuid,
  capabilityUuid,
  payload,
  {
    companyUuid,
    activityUuid,
  } = {},
) {
  const response = await api.patch(
    buildSupplierCapabilityPath(
      supplierUuid,
      capabilityUuid,
    ),
    payload,
    buildSupplierCapabilityScopeConfig({
      companyUuid,
      activityUuid,
    }),
  );

  return response?.data?.capability
    || null;
}


export {
  buildSupplierCapabilityScopeConfig,
};
